import React, { ChangeEvent, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { FormInputProps } from './types';

const FormInput = ({
  name,
  label,
  value = '',
  placeholder,
  handleInputChange,
  onKeyDown,
  type = 'text',
  maxCharacters,
  setIsMaxCharactersError,
  focusOnMount = false,
  disabled = false,
  marginButton = 4,
}: FormInputProps) => {
  const [error, setError] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (maxCharacters && e.target.value.length > maxCharacters) {
      setError(true);
      setIsMaxCharactersError?.(true);
    } else {
      setError(false);
      setIsMaxCharactersError?.(false);
      handleInputChange(e);
    }
  };

  return (
    <Box mb={marginButton}>
      {typeof label === 'string' ? (
        <Typography variant="body1" gutterBottom style={{ fontWeight: 700 }}>
          {label}
        </Typography>
      ) : (
        label
      )}
      <TextField
        name={name}
        variant="outlined"
        fullWidth
        value={value}
        onChange={handleChange}
        {...(onKeyDown && { onKeyDown })}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
        multiline={type === 'textarea'}
        error={error}
        helperText={error && maxCharacters ? `Max characters: ${maxCharacters}` : ''}
        autoFocus={focusOnMount}
      />
    </Box>
  );
};

export default FormInput;
